import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import "react-modern-drawer/dist/index.css";
import "./styles/Css/theme/default.css";
import "./styles/Css/theme/foundation.css";
import "./styles/crow.css";
import "./styles/iconmoon/style.css";
import 'rc-tooltip/assets/bootstrap_white.css';
import "./styles/Css/theme/MenuTables.css";
import "./styles/Css/theme/StatusTable.css";

const container = document.getElementById('root');

if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);

root.render(
  <App />
);